import uniq from 'lodash/uniq';
import type { CatalogGamesFilters, GetCatalogGamesResponse } from 'src/types/catalog-games';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'CatalogGames';

interface GameModal {
  isOpen: boolean;
  type: 'new' | 'duplicate' | 'edit' | 'delete' | 'details' | null;
  data: GetCatalogGamesResponse['values'][0] | null;
}

export type CatalogGamesStoreState = {
  filters: CatalogGamesFilters;
  gameModal: GameModal;
  creationResultIds: string[];
  setFilters: (filters: CatalogGamesFilters) => void;
  setInitialFilters: () => void;
  setGameModal: (gameModal: GameModal) => void;
  addCreationResultIds: (creationResultIds: string[]) => void;
  removeCreationResultIds: (creationResultIds: string[]) => void;
};

const initialState: Pick<CatalogGamesStoreState, 'filters' | 'gameModal' | 'creationResultIds'> = {
  filters: {
    gameNameQuery: '',
    gameProviderNameQuery: '',
    gameProviderNames: [],
    gameTypes: [],
    features: [],
    themes: [],
    genres: [],
    otherTags: [],
    zingGameTraits: [],
    zingHighLevelGameTypes: [],
    zingLowLevelGameTypes: [],
    zingPrimaryFeaturesFromGameName: [],
    zingSecondaryFeaturesFromGameName: [],
    isManual: null,
  },
  gameModal: { isOpen: false, type: null, data: null },
  creationResultIds: [],
};

export const useCatalogGamesStore = create<CatalogGamesStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setFilters: (filters) => set(() => ({ filters })),
      setInitialFilters: () => set(() => ({ filters: initialState.filters })),
      setGameModal: (gameModal) => set(() => ({ gameModal })),
      addCreationResultIds: (creationResultIds) =>
        set((state) => ({
          creationResultIds: uniq(state.creationResultIds.concat(creationResultIds)),
        })),
      removeCreationResultIds: (creationResultIds) =>
        set((state) => ({
          creationResultIds: state.creationResultIds.filter((id) => !creationResultIds.includes(id)),
        })),
    }),
    { name: STORE_NAME },
  ),
);
